import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  PasswordResetBodyT,
  SessionLogoutBodyT,
} from 'server/controllers/auth';

import {
  P_API_AUTH_PASSWORD_RESET,
  P_API_AUTH_SESSION_LOGOUT,
  type UserT,
  getConfig,
} from 'utils';

import { getFirebaseClientService } from './getClient';

export async function logout(): Promise<void> {
  assertClientSide();

  const config = await getConfig();

  await axios.post(P_API_AUTH_SESSION_LOGOUT, {
    _csrf: config.CSRF,
  } satisfies SessionLogoutBodyT);
}

type ArgT = {
  email: string;
  password: string;
  token: string;
  userId: string;
};

export async function resetPasswordEnd({
  email,
  password,
  token,
  userId,
}: ArgT): Promise<UserT> {
  const { signInWithEmailAndPassword } = await getFirebaseClientService();

  const fb = await getFirebaseClientService();
  const appCheckToken = await fb.getAppCheckToken(true);
  if (!appCheckToken) throw Error('Failed app-check');

  const config = getConfig(true);

  await axios.post(P_API_AUTH_PASSWORD_RESET, {
    _csrf: config.CSRF,
    appCheckToken,
    password,
    token,
    userId,
  } satisfies PasswordResetBodyT);

  const user = await signInWithEmailAndPassword(email, password);

  return user;
}
